<template>
    <base-field 
        :annotation="annotation" 
        :scale="scale"
        :selected="selected"
        :editable="editable"
        @field-click="handleClick"
        @position-change="$emit('position-change', $event)"
    >
        <div class="select-field-display">
            <select
                v-if="editing"
                v-model="localValue"
                @change="handleChange"
                @blur="handleBlur"
                ref="selectInput"
                class="select-input"
            >
                <option value="">Select an option...</option>
                <option 
                    v-for="option in annotation.properties.options" 
                    :key="option.value"
                    :value="option.value"
                >
                    {{ option.label }}
                </option>
            </select>
            <div v-else class="select-display" :class="{ 'has-value': !!value }">
                <span v-if="selectedOptionLabel">{{ selectedOptionLabel }}</span>
                <span v-else class="placeholder-text">
                    <i class="fa fa-list"></i>
                    {{ annotation.label || annotation.fieldName || 'Select option' }}
                </span>
                <i class="fa fa-chevron-down select-arrow"></i>
            </div>
        </div>
    </base-field>
</template>

<script>
import Vue from 'vue';
import BaseField from './BaseField.vue';

export default {
    name: 'SelectField',
    components: { BaseField },
    props: {
        annotation: {
            type: Object,
            required: true
        },
        value: {
            type: String,
            default: ''
        },
        scale: {
            type: Number,
            default: 1
        },
        selected: {
            type: Boolean,
            default: false
        },
        editing: {
            type: Boolean,
            default: false
        },
        editable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localValue: this.value || ''
        };
    },
    computed: {
        selectedOptionLabel() {
            if (!this.value) return '';
            const option = this.annotation.properties.options.find(opt => opt.value === this.value);
            return option ? option.label : this.value;
        }
    },
    watch: {
        value(newValue) {
            this.localValue = newValue || '';
        },
        editing(isEditing) {
            if (isEditing) {
                this.$nextTick(() => {
                    const select = this.$refs.selectInput;
                    if (select) {
                        select.focus();
                    }
                });
            }
        }
    },
    methods: {
        handleClick() {
            if (!this.editing) {
                this.$emit('field-click', this.annotation);
            }
        },
        
        handleChange() {
            this.$emit('value-change', this.annotation.fieldName, this.localValue);
        },
        
        handleBlur() {
            this.$emit('edit-end', this.annotation);
        }
    }
};
</script>

<style scoped>
.select-field-display {
    width: 100%;
    height: 100%;
}

.select-input {
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    background: transparent;
    font-size: 14px;
    padding: 4px;
}

.select-display {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px 8px;
    background-color: #fff;
    border: 1px dashed #ccc;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
}

.select-display.has-value {
    border: 1px solid #e2e8f0;
}

.placeholder-text {
    color: #718096;
    font-style: italic;
    display: flex;
    align-items: center;
    gap: 8px;
}

.placeholder-text i {
    font-size: 12px;
}

.select-arrow {
    color: #718096;
    font-size: 12px;
    margin-left: 8px;
}
</style>